"use client";

import dynamic from "next/dynamic";

export const CartModal = dynamic(() => import("./CartModal").then((mod) => mod.CartModal));
export const CartContent = dynamic(() => import("./CartContent").then((mod) => mod.CartContent));
export const CartItems = dynamic(() => import("./CartItems").then((mod) => mod.CartItems));

export const CartSummary = dynamic(() => import("./CartSummary").then((mod) => mod.CartSummary));

export const CartAmount = dynamic(() => import("./CartAmount").then((mod) => mod.CartAmount));

export const CartUpsell = dynamic(() => import("./CartUpsell").then((mod) => mod.CartUpsell));
